export default class Util {

    public static substituiUrlsImagens(html: string) {
        if (html) {
            html = html.replaceAll("\"cosis/galeria/imagem", "\"https://sisweb.tesouro.gov.br/apex/cosis/galeria/imagem");
            html = html.replaceAll("\"cosis/helpo/imagem", "\"https://sisweb.tesouro.gov.br/apex/cosis/helpo/imagem");
            html = html.replaceAll("\"cosis_public.obtem_imagem?", "\"https://sisweb.tesouro.gov.br/apex/cosis_public.obtem_imagem?");
        }
        return html;
    }

    public static ajustarContraste(corHexadecimal: string): string {
        // Remover o '#' do início, se presente
        corHexadecimal = corHexadecimal.replace("#", "");

        // Converter a cor hexadecimal para RGB
        const vermelho = parseInt(corHexadecimal.substr(0, 2), 16);
        const verde = parseInt(corHexadecimal.substr(2, 2), 16);
        const azul = parseInt(corHexadecimal.substr(4, 2), 16);

        // Calcular o brilho da cor usando a fórmula (0.299*R + 0.587*G + 0.114*B)
        const brilho = (0.299 * vermelho + 0.587 * verde + 0.114 * azul) / 255;

        // Definir o valor de limite para determinar cores escuras ou claras (ajuste conforme necessário)
        const limite = 0.5;

        // Escolher a cor de contraste apropriada com base no brilho
        const corContraste = brilho > limite ? "#000000" : "#FFFFFF";

        return corContraste;
    }

    /**
     * Decodifica um token JWT e verifica se ele não expirou.
     * @param token O token JWT a ser validado.
     * @returns `true` se o token for válido e não estiver expirado, `false` caso contrário.
     */
    public static isJwtTokenValid(token: string | null): boolean  {
        if (!token) {
            return false;
        }

        try {
            // 1. O JWT é dividido em 3 partes: header, payload, signature. Pegamos o payload.
            const payloadBase64 = token.split('.')[1];
            if (!payloadBase64) {
                return false; // Token malformado
            }

            // 2. Decodificamos o payload de Base64 para uma string JSON.
            const decodedPayloadJson = atob(payloadBase64);

            // 3. Parseamos a string JSON para um objeto JavaScript.
            const payload = JSON.parse(decodedPayloadJson);

            // 4. Verificamos se a propriedade 'exp' (expiration time) existe.
            if (!payload.exp || typeof payload.exp !== 'number') {
                return false; // Sem data de expiração, consideramos inválido.
            }

            // 5. O 'exp' é em segundos. Convertemos para milissegundos para comparar com Date.now().
            const expirationTimeInMs = payload.exp * 1000;

            // 6. Comparamos a data de expiração com a data/hora atual.
            return expirationTimeInMs > Date.now();

        } catch (error) {
            // Se qualquer passo falhar (ex: token malformado, JSON inválido), o token é inválido.
            console.error("Erro ao validar o token JWT:", error);
            return false;
        }
    };


}